export type EditorAssistantContext = {
    durationSec: number;
    hasVideo: boolean;
    sourceCount: number;
    transcriptState: "none" | "processing" | "ready";
    suggestChapters: boolean;
};

type ContextSources = {
    compositionDurationSec: number;
    hasVideo: boolean;
    scriptClip?: any;
    projectTracks: any[];
};

const PROCESSING_STATES = new Set(["queued", "processing", "client_extracting", "pending"]);

export const buildEditorAssistantContext = (sources: ContextSources): EditorAssistantContext => {
    const scriptClip = sources.scriptClip;
    const currentAudioEntries = scriptClip?.getAudioEntries?.();
    const audioEntries: any[] = Array.isArray(currentAudioEntries) ? currentAudioEntries : [];
    const tracks = sources.projectTracks ?? [];
    const sourceTracks = audioEntries.map((entry) => {
        const assetId = String(entry?.assetId ?? "").trim();
        return tracks.find((track: any) =>
            assetId && [track?.id, track?.trackId, track?.assetId].some((id) => String(id ?? "") === assetId)
        );
    });

    const states = sourceTracks.map((track: any) => String(track?.transcriptionState ?? "").trim().toLowerCase());
    const transcriptState = states.some((state) => PROCESSING_STATES.has(state))
        ? "processing"
        : sourceTracks.length > 0 && sourceTracks.every(
            (track: any, index) => states[index] === "completed" || Boolean(track?.activeTranscriptId)
        )
            ? "ready"
            : "none";
    const duration = Number(sources.compositionDurationSec ?? 0);
    const durationSec = Number.isFinite(duration) && duration > 0 ? Math.round(duration * 100) / 100 : 0;

    return {
        durationSec,
        hasVideo: Boolean(sources.hasVideo),
        sourceCount: audioEntries.length,
        transcriptState,
        suggestChapters: durationSec >= 10 * 60 && transcriptState === "ready",
    };
};
